<template>

  <div class="tree" ref="treeBox" @click.stop="showContextMenu = false">
    <div class="opt">
      <div style="display: flex">
        <el-button style="padding:0px 9px;color:#409eff;border:1px solid #409eff;" plain size="mini" @click="transUnfold">全部{{isUnfold ? '折叠':'展开'}}</el-button>
        <!-- <el-button style="padding:0px 9px" type="primary" size="mini" @click="close">全部折叠</el-button> -->
      </div>
      <div class="btnList">
        <el-popover placement="right" trigger="hover">
          <div class="btnBox" style="display:flex;">
            <el-button type="text" @click="showAddGroup(1)">新增分组</el-button>
            <el-button type="text" @click="downloadFileGet">下载模板</el-button>
            <el-upload action accept=".xlsx,.xls" :before-upload="beforeUpload" :http-request="uploadFile" :show-file-list="false">
              <el-button type="text" style="margin-left:10px;">导入模型</el-button>
            </el-upload>
          </div>
          <el-button class="el-icon-more-button" slot="reference" round type="text" icon="el-icon-more"></el-button>
        </el-popover>
      </div>
    </div>

    <el-tree class="tree1" icon-class="el-icon-menu" :data="treeList" node-key="tree_id" default-expand-all @node-click="changeModel" :props="defaultProps" ref="modeltree">
      <div
        class="custom-tree-node"
        :class="{ disable: scope.data.disabled == '0' ? 0 : 1 }"
        :style="{ color: currentModel === scope.data.id ? '#1890ff' : '' }"
        slot-scope="scope"
        @contextmenu.stop.prevent="openMenu($event, scope.node, scope.data)"
      >

        <div class="jt">
          <p class="custom-tree-node-label">
            <!-- <el-popover placement="top-start" trigger="hover" :content="scope.node.label">
              <span slot="reference">{{ scope.node.label }}</span>
            </el-popover> -->
            <el-tooltip class="item" effect="dark" :content="scope.node.label" :enterable="false" placement="top">
              <span>{{ scope.node.label }}</span>
            </el-tooltip>
          </p>
          <div>
            <el-button v-if="scope.node.previousSibling" size="medium" type="text" icon="el-icon-top" @click.stop="up(scope)"></el-button>
            <el-button v-if="scope.node.nextSibling" type="text" size="medium" icon="el-icon-bottom" @click.stop="down(scope)"></el-button>
            <span v-if="!scope.node.nextSibling" style="margin-right:25px"></span>
          </div>
        </div>
      </div>
    </el-tree>

    <ul v-show="showContextMenu" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li v-for="(item, index) in menuList" :key="index" @click="clickContextMenu(item.event)">
        <i :class="item.icon" style="padding-right:10px;"></i>
        <span>{{ item.label }}</span>
      </li>
    </ul>

  </div>

</template>

<script>
import { fetchModelTree,addModelObj,editModelObj,exchangeModelSort,exchangeModelGroupSort,editModelDisabled,deleteModel,
addModelGroup,importModelData,getModelGroupDetail,editModelGroup,editModelGroupDisabled,deleteModelGroup } from '@/page/modelManage/api/model'
import {baseUrl} from '@/config'
// import ImageUpload from './ImageUpload'
// import Dialog from './Dialog'

// let GroupMenu = [
//     { label: '新增模型', event: 'addModel', icon: 'el-icon-circle-plus-outline' },
//     { label: '编辑', event: 'editGroup', icon: 'el-icon-edit' }
//   ],
//   ModelMenu = [{ label: '编辑', event: 'editModel', icon: 'el-icon-edit' }]
export default {
  name: 'ModelTree',
  props: ['currentModel'],
  data() {
    return {
      showContextMenu: false,
      selectUser: false,
      left: 0,
      top: 0,
      menuList: [],
      menuNode: {
        node: {},
        data: {}
      },
      iconId: '',
      group: {
        id: '',
        name: '',
        remark: '',
        disabled: '',
        level: '',
        pid: ''
      },
      model: {
        id: '',
        tid: '',
        name: '',
        readonly: 0,
        show_type: '1',
        show_resource: 1,
        need_resource: 0,
        data_reuse: 0,
        remark: '',
        form_unique_type: '',
        // view_data_level: 1,
        icon: '',
        need_flow: 0,
        sort: '',
        data_inputed:0
      },
      data_inputed:0,
      users: [],
      select: [],
      grouprules: {
        name: [
          { required: true, message: '请输入分组名称', trigger: 'blur' },
          { max: 50, message: '最多不能超过50字符', trigger: 'blur' }
        ]
      },
      modelrules: {
        tid: [{ required: true, message: '请输入模型ID', trigger: 'blur' }],
        name: [
          { required: true, message: '请输入模型名称', trigger: 'blur' },
          { max: 50, message: '最多不能超过50字符', trigger: 'blur' }
        ],
        readonly: [{ required: true, message: '请选择是否只读', trigger: 'blur' }],
        show_type: [{ required: true, message: '请选择展示类型', trigger: 'blur' }],
        show_resource: [{ required: true, message: '请选择是否上传佐证材料', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        form_unique_type: [{ required: true, message: '请选择数据唯一' }],
        // view_data_level: [{ required: true, message: '请选择数据查看级别' }],
        need_resource: [{ required: true, message: '请选择佐证材料是否必填', trigger: 'blur' }],
        data_reuse: [{ required: true, message: '请选择数据是否再次使用', trigger: 'change' }]
      },
      treeList: [],
      departments: [],
      user: [],
      dept: [],
      groupId: '',
      showEditModel: false,
      modelId: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      iconPath: '',
      fileList: {},
      uploadUrl: '',
      baseURL: '',
      treeModelId: '',
      tip: '只能上传png、jpg、jpeg格式文件',
      accept: '.png,.jpg,.jpeg',
      label: '',
      needManege: '',
      isUnfold:true,
      warnVisible:false,
      warnList:[],
      modelOption:{
          span:24,
          column: [
            {
              label: "TID",
              prop: "tid",
              rules: [{
                required: true,
                message: "请输入TID",
                trigger: "blur"
              }]
            },
            {
              label: "名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入名称",
                trigger: "blur"
              }
              ]
            },
            {
              label: '备注',
              prop: 'remark',
              type: 'textarea',
              minRows:3,
              maxRows:5
            }
          ]
      },
      groupOption:{
          span:24,
          column: [
            {
              label: "名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入名称",
                trigger: "blur"
              }
              ]
            }
          ]
      }

    }
  },

  mounted() {
    this.getModelList()
    // eslint-disable-next-line no-undef
    // this.baseURL = config.baseURL + this.$store.getters.attachmentRoot.attachment_root
    // eslint-disable-next-line no-undef
    // this.needManege = config.needManege
    // this.uploadUrl = '/sys/resource_file/upload/meta_model_icon'
    // /sys/resource_file/upload/{folder}
  },

  methods: {
    saveModelPost(data){
      addModelObj(data).then(resp=>{
        if(resp.data.success){
          this.getModelList();
        }
      })
    },
    saveEditModelPost(data){
      editModelObj(data).then(resp=>{
        if(resp.data.success){
          this.getModelList();
        }
      })
    },
    showModelDialog(type){
       this.$DialogForm.show({
          title: '新增',
          width: '50%',
          type:type,
          menuPosition:'right',
          option: this.modelOption,
          beforeClose: (done) => {
            done()
          },
          callback:(res)=>{
              res.done();
              let source = res.data
              let savedata = Object.assign(this.model,source);
              savedata.meta_model_group_id=this.menuNode.data.id;
              this.saveModelPost(savedata);
              res.close();
          }
        })
    },
    showModelEditDialog(type){
       this.$DialogForm.show({
          title: '编辑',
          width: '50%',
          type:type,
          menuPosition:'right',
          data:this.menuNode.data,
          option: this.modelOption,
          beforeClose: (done) => {
            done()
          },
          callback:(res)=>{
              res.done();

              let source = res.data
              // console.log(source)
              let savedata = Object.assign(this.model,source);
              savedata.meta_model_group_id=this.menuNode.data.id;
                            // console.log(savedata)
              this.saveEditModelPost(savedata);
              res.close();
          }
        })
    },
    showAddGroup(level, node){
      if (level == 1) {
        this.group = {
          id: '',
          name: '',
          remark: '',
          disabled: '',
          icon:'',
          level: 1,
          pid: '0'
        }
      } else {
        this.group = {
          id: '',
          name: '',
          remark: '',
          disabled: '',
          icon:'',
          level: 2,
          pid: node.id
        }
      }
       this.$DialogForm.show({
          title: '新增',
          width: '50%',
          menuPosition:'right',
          option: this.groupOption,
          beforeClose: (done) => {
            done()
          },
          callback:(res)=>{
              res.done();
              let source = res.data
              let savedata = Object.assign(this.group,source);
              this.addGroupSave(savedata);
              res.close();
          }
        })
    },
    showEditGroup(){
      this.groupId = this.menuNode.data.id
      getModelGroupDetail(this.groupId).then(res => {
        if (res.data.success) {
          this.group = res.data.data
          this.$DialogForm.show({
          title: '编辑',
          width: '50%',
          menuPosition:'right',
          data:this.group,
          option: this.groupOption,
          beforeClose: (done) => {
            done()
          },
          callback:(res)=>{
              res.done();
              let source = res.data
              let savedata = Object.assign(this.group,source);
              this.editGroupSave(savedata);
              res.close();
          }
        })
        }
      })

    },
    addGroupSave(data){
      addModelGroup(data).then(res=>{
        if(res.data.success){
          this.getModelList();
        }
      })
    },
    editGroupSave(data){
      editModelGroup(data).then(res=>{
        if(res.data.success){
          this.getModelList();
        }
      })
    },
    downloadFileGet(){
      let url = baseUrl+'/download/inside_file?d=template&fn=meta_model_import&dn=数据模型导入模板&s=xlsx';
      window.open(url)
    },
    onChange() {
      this.$forceUpdate()
    },
    //获取模型树列表
    getModelList() {

        fetchModelTree().then(res => {
          if (res.data.success) {
            let treeList = res.data.data
            treeList.forEach(item => {
              if (item.children) {
                this.treeModelId = item.id
              }
            })
            this.treeList = treeList
          }
        })
    },
    transUnfold() {
      this.isUnfold = !this.isUnfold
      this.changeExpanded(this.$refs.modeltree.store.root, this.isUnfold)
    },
    changeExpanded(node, flag) {
      node.expanded = flag
      if (node.childNodes && node.childNodes.length) {
        node.childNodes.forEach(item => {
          this.changeExpanded(item, flag)
        })
      }
    },
    up(data) {
      if (!data.data.level) {
       exchangeModelSort({
            id1: data.data.id,
            id2: data.node.previousSibling.data.id
          })
          .then(res => {
            if (res.data.success) {
              this.getModelList()
            }
          })
      } else {
        exchangeModelGroupSort({
            id1: data.data.id,
            id2: data.node.previousSibling.data.id
          })
          .then(res => {
            if (res) {
              this.getModelList()
            }
          })
      }
    },
    down(data) {
      if (!data.data.level) {
          exchangeModelSort({
            id1: data.data.id,
            id2: data.node.nextSibling.data.id
          })
          .then(res => {
            if (res.data.success) {
              this.getModelList()
            }
          })

      } else {
        exchangeModelGroupSort({
            id1: data.data.id,
            id2: data.node.nextSibling.data.id
          })
          .then(res => {
            if (res) {
              this.getModelList()
            }
          })

      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.iconPath = ''
      this.iconId = ''
      this.users = []
    },
    changeModel(obj, node, model) {
      console.log('obj', obj)
      this.$emit('change', {
        level: obj.level,
        id: obj.id,
        data_inputed:obj.data_inputed
      })
      this.showContextMenu = false
    },
    unique(arr) {
      if (arr) {
        // 根据唯一标识orderId来对数组进行过滤
        const res = new Map() //定义常量 res,值为一个Map对象实例 //返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
        return arr.filter(arr => !res.has(arr.id) && res.set(arr.id, 1))
      }
    },
    getUser() {
      this.$nextTick(() => {
        console.log(this.$refs.dialog, 'this.$refs.dialog')
        this.$refs.dialog.getAllUserList()
        this.$refs.dialog.getDeptList()
        this.$refs.dialog.reset()
      })
    },

    saveUser(users) {
      this.select = users
      this.users = [...this.users, ...this.select]
      this.users = this.unique(this.users)
    },

    closeDialog(selectUser) {
      this.selectUser = selectUser
    },
    handleClose(index) {
      this.users.splice(index, 1)
    },
    // 右键
    openMenu(ev, node, data) {
      console.log(data)
      this.left = ev.x
      this.showContextMenu = true
      let menuList = []
      if (node.level == 1) {
        menuList = [
          { label: '新增二级分组', event: 'addSecondGroup', icon: 'el-icon-circle-plus-outline' },
          { label: '编辑', event: 'showEditGroup', icon: 'el-icon-edit' },
          {
            label: data.disabled == '0' ? '禁用' : '启用',
            event: 'switchGroup',
            icon: data.disabled == '0' ? 'el-icon-remove-outline' : 'el-icon-video-pause'
          }
        ]
        if (!data.children || !data.children.length) {
          menuList.push({
            label: '删除',
            event: 'deleteGroup',
            icon: 'el-icon-delete'
          })
        }
      } else if (node.level == 2) {
        menuList = [
          { label: '新增模型', event: 'showModelDialog', icon: 'el-icon-circle-plus-outline' },
          { label: '编辑', event: 'showEditGroup', icon: 'el-icon-edit' },
          {
            label: data.disabled == '0' ? '禁用' : '启用',
            event: 'switchGroup',
            icon: data.disabled == '0' ? 'el-icon-remove-outline' : 'el-icon-video-pause'
          }
        ]
        if (!data.children || !data.children.length) {
          menuList.push({
            label: '删除',
            event: 'deleteGroup',
            icon: 'el-icon-delete'
          })
        }
      } else {
        menuList = [
          {
            label: data.disabled == '0' ? '禁用' : '启用',
            event: 'switchModel',
            icon: data.disabled == '0' ? 'el-icon-remove-outline' : 'el-icon-video-pause'
          },
        ]
        if(data.data_inputed == 1) {
          menuList.unshift({ label: '编辑', event: 'showModelEditDialog', icon: 'el-icon-edit' })
        }
        if(data.data_inputed == 1) {
          menuList.push({ label: '删除', event: 'deleteModel', icon: 'el-icon-delete' })
        }
      }
      if(ev.y > this.$refs.treeBox.offsetHeight - (25 * menuList.length)) {
        this.top = ev.y - (25 * menuList.length)
      }else {
        this.top = ev.y
      }
      this.menuList = menuList
      this.menuNode = { ...node, ...data }
    },
    // 点击右键菜单
    clickContextMenu(event) {
      if (this[event]) {
        this[event]()
      }
    },
    // 添加新分组
    addGroup(level, node) {
      if (level == 1) {
        this.group = {
          id: '',
          name: '',
          remark: '',
          disabled: '',
          level: 1,
          pid: '0'
        }
      } else {
        this.group = {
          id: '',
          name: '',
          remark: '',
          disabled: '',
          level: 2,
          pid: node.id
        }
      }
      this.showEditGroup = true

      this.iconPath = ''
      console.log(this.group, 'this.group')
    },
    //添加新分组
    confirmgroup(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.group.id) {
            this.$api
              .editModelGroup({
                id: this.group.id,
                name: this.group.name,
                icon: this.iconId,
                remark: this.group.remark,
                level: this.group.level,
                pid: this.group.pid
              })
              .then(res => {
                if (res) {
                  this.showEditGroup = false
                  this.group.id = ''
                  this.$message({
                    message: '编辑分组成功！',
                    type: 'success'
                  })
                  this.getModelList()
                }
              })
          } else {
            this.$api
              .addModelGroup({
                name: this.group.name,
                icon: this.iconId,
                remark: this.group.remark,
                level: this.group.level,
                pid: this.group.pid
              })
              .then(res => {
                if (res) {
                  this.showEditGroup = false
                  this.$message({
                    message: '添加分组成功！',
                    type: 'success'
                  })
                  this.getModelList()
                }
              })
          }
        }
      })
    },
    // 点击编辑分组
    editGroup() {
      this.showEditGroup = true
      this.groupId = this.menuNode.data.id
      this.$api.getModelGroupDetail(this.groupId).then(res => {
        if (res) {
          this.group = res.data
          this.iconPath = res.data.icon_path
          this.iconId = res.data.icon
        }
      })
    },
    // 选择主管人员
    SeleUser() {
      this.selectUser = true
      this.$nextTick(() => {
        this.$refs.dialog.getAllUserList()
      })
    },
    beforeUpload(e) {
      if (e.size > 100000000) {
        this.$message.warning('上传文件不能超过1000M')
        return false
      }
    },
    async uploadFile(fileObj) {
      // 上传文件请求复写
      console.log(fileObj, 'fileObj')
      const formData = new FormData()
      formData.append('file', fileObj.file)
      const res = await importModelData(formData)
      if (res.data.success ) {
        if(!res.data.data.length) {
          this.$message.success('操作成功')
        }else {
          this.warnVisible = true
          let titleArr = [...new Set(res.data.data.map(item => item.sheet_name))]
          let arr = []
          titleArr.forEach(item => {
            arr.push({
              name:item,
              list:[]
            })
          });
          arr.forEach(title => {
            res.data.data.forEach(item => {
              if(item.sheet_name ==  title.name) {
                title.list.push(item)
              }
            });
          });
          this.warnList = arr
        }
        this.getModelList()
        this.$emit('importSuc')
      }
    },
    //确认添加编辑
    confirmmodel(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // if (this.users) {
          //   this.user = this.users.map(item => {
          //     return item.id
          //   })
          //   this.dept = this.users.map(item => {
          //     return item.dept_id
          //   })
          // }
          if (this.model.id) {
            this.$api
              .editModel({
                id: this.model.id,
                tid: this.model.tid,
                name: this.model.name,
                readonly: this.model.readonly,
                show_type: this.model.show_type,
                show_resource: this.model.show_resource,
                need_resource: this.model.need_resource,
                data_reuse: this.model.data_reuse,
                sort: this.model.sort,
                icon: this.iconId,
                remark: this.model.remark,
                form_unique_type: this.model.show_type == 1 ? '' : this.model.form_unique_type
                // view_data_level: this.model.view_data_level
              })
              .then(res => {
                if (res) {
                  this.showEditModel = false
                  this.model.id = ''
                  this.$message.success('编辑模型成功！')
                  this.getModelList()
                }
              })
              .catch(e => {
                // this.$message.error('编辑模型失败！')
              })
          } else {
            this.$api
              .addModel({
                meta_model_group_id: this.menuNode.data.id,
                tid: this.model.tid,
                name: this.model.name,
                readonly: this.model.readonly,
                show_type: this.model.show_type,
                show_resource: this.model.show_resource,
                need_resource: this.model.need_resource,
                data_reuse: this.model.data_reuse,
                sort: this.model.sort,
                icon: this.iconId,
                remark: this.model.remark,
                form_unique_type: this.model.show_type == 1 ? '' : this.model.form_unique_type
                // view_data_level: this.model.view_data_level
              })
              .then(res => {
                if (res) {
                  this.showEditModel = false
                  this.$message({
                    message: '新增模型成功！',
                    type: 'success'
                  })
                  this.getModelList()
                }
              })
              .catch(e => {
                return
              })
          }
        }
      })
    },
    // 点击分组启用开关
    switchGroup() {
      let disable = ''

      if (this.menuNode.data.disabled == '1') {
        disable = 0
      } else {
        disable = 1
      }
      editModelGroupDisabled({
          id: this.menuNode.data.id,
          disabled: disable
        })
        .then(res => {
          if (res.data.success) {
            this.getModelList()
          }
        })
    },


    // 点击模型启用开关
    switchModel() {
      let disable = ''

      if (this.menuNode.data.disabled == '1') {
        disable = 0
      } else {
        disable = 1
      }
      editModelDisabled({
          id: this.menuNode.data.id,
          disabled: disable
        })
        .then(res => {
          if (res.data.success) {
            this.getModelList()
          }
        })
    },
    getFiles(files) {
      this.filesList = {}
      this.filesList = files
      this.iconId = this.filesList.id
    },
    deleteGroup() {
      // console.log(this.menuNode.data.id,this.currentModel);
      this.$confirm('此操作将删除该分组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteModelGroup(this.menuNode.data.id).then(res => {
            if (res.data.success ) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.resetModelId()
              this.getModelList()
            }
          })
        })
        .catch(() => {
          return
        })
    },
    addSecondGroup() {
      this.showAddGroup(2, this.menuNode)
    },
    // 如果当前删除的模型id 等于当前打开的页面则清除改模型id
    resetModelId(){
      if(this.menuNode.data.id === this.currentModel){
        this.$emit('resetModelId')
      }
    },
    // 点击删除模型
    deleteModel() {
      this.$confirm('此操作将删除该模型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
         deleteModel(this.menuNode.data.id).then(res => {
            if (res.data.success ) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.resetModelId()
              this.getModelList()
            }
          })
        })
        .catch(() => {
          return
        })
    }
  },
  computed: {
    META_MODEL_SHOW_TYPE() {
      let arr = this.$store.getters.dicList.META_MODEL_SHOW_TYPE || []
      return arr
    },
    META_MODEL_FORM_UNIQUE_TYPE() {
      let arr = this.$store.getters.dicList.META_MODEL_FORM_UNIQUE_TYPE || []
      return arr
    },
    disabledEdit() {
      let flag = true
      if(this.model.id) {
        if(this.model.data_inputed == 0) {
          flag = true
        }else {
          flag = false
        }
      }else {
        flag = false
      }
      return flag
    }
  }
}
</script>

<style scoped lang="less">
 /deep/ .el-tree-node.is-current > .el-tree-node__content {
  color: #606266 !important;
}

.model{
  font-size: 7px;

}

.el-icon-more-button{
  transform: rotate(90deg);
}

.tree {
  height: 100%;
  // overflow: auto;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #e1e1e1;
    margin-top: -10px;
    margin-bottom: -10px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    border-radius:4px;
  }

  ul,
  li {
    list-style: none;
  }

  .contextmenu {
    position: fixed;
    z-index: 1;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.7));
    border-radius: 5px;
    color: #ffffff;
    font-size: 12px;
    // line-height: 25px;
    padding-left: 0;
    li {
      padding: 5px 10px;
      border-radius: 5px;
      height: 25px;
      cursor: pointer;

      &:hover {
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }
  .opt {
    width: 320px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    box-sizing: border-box;
  }

  .custom-tree-node {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 26px;
    // background-color: red;
    .custom-tree-node-icon {
      width: 16px;
      height: 16px;
      border-radius: 2px;
      object-fit: cover;
    }

    .custom-tree-node-label {
      // flex: 1;
      width: 180px;
      margin-left: 4px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-top: 0;
      margin-bottom: 0;
    }

    &.disable {
      color: #999999;
      text-decoration: line-through;
    }
  }
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 86px;
  height: 86px;
  line-height: 86px;
  text-align: center;
}

/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}

/deep/ .el-dialog__body {
  padding: 10px 20px;
}

.tree1 {
  font-size: 14px;
  background: #141C3A;
  color: #FFF;
  
}
.footer {
  padding-top: 20px;
  text-align: center;
}

/deep/ .el-form-item {
  margin-bottom: 15px;
}

.jt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
.btnList {
  /deep/ .el-popover {
    min-width: 0 !important;
  }
  .el-button--small.is-round {
    padding: 9px 0;
  }
}
/deep/ .el-tree {
  .el-tree-node__content:hover{
    background: #1b2342;
  }
  .el-tree-node.is-current>.el-tree-node__content {
    background: #1b2342;
    color: #2189FF !important;
  }
  .el-tree-node:focus>.el-tree-node__content {
    background-color: #1b2342;
  }
}
</style>